// extracted by mini-css-extract-plugin
export default {"block":"Languages_block__e+Eyu","dropdown":"Languages_dropdown__fWUHe","toggle":"Languages_toggle__AHaip","icon":"Languages_icon__g15FW","image":"Languages_image__HmD21"};